import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import AppealRequestComponent from "../../components/applicationComponents/appealRequest/AppealRequestComponent";

export default function AppealRequestPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Appeal Request",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);
  return (
    <>
      <AppealRequestComponent disabled={false} showBack={true} showEdit={false} />
    </>
  );
}
